import en from './translations/en'

let trans = en

export default { trans }